// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityFiltersPage-StateFilter-StateFilter-module__select--fXMYa {
  width: 100%;
}
.src-pages-EntityFiltersPage-StateFilter-StateFilter-module__select--fXMYa .ant-select-selection-item {
  padding-inline: 0;
  background: transparent;
  border: 0;
}
.src-pages-EntityFiltersPage-StateFilter-StateFilter-module__actions--wzlUa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 4px 4px;
  border-top: 1px solid #0000000f;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityFiltersPage/StateFilter/StateFilter.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAFA;EAII,iBAAA;EACA,uBAAA;EACA,SAAA;AACJ;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,oBAAA;EACA,+BAAA;AADF","sourcesContent":[".select {\n  width: 100%;\n\n  :global(.ant-select-selection-item) {\n    padding-inline: 0;\n    background: transparent;\n    border: 0;\n  }\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 4px 4px;\n  border-top: 1px solid #0000000f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `src-pages-EntityFiltersPage-StateFilter-StateFilter-module__select--fXMYa`,
	"actions": `src-pages-EntityFiltersPage-StateFilter-StateFilter-module__actions--wzlUa`
};
export default ___CSS_LOADER_EXPORT___;
